/**
 * dataworkman i18n Translation Resources
 */

export const translations = {
  ko: {
    // Navigation
    "nav.home": "홈",
    "nav.services": "서비스",
    "nav.portfolio": "포트폴리오",
    "nav.process": "프로세스",
    "nav.contact": "프로젝트 의뢰",

    // Hero Section
    "hero.badge": "Custom software for small business",
    "hero.title": "현장에서 바로 쓰는<br>업무용 앱과 자동화",
    "hero.subtitle": "주문, 예약, 매장 운영, 콘텐츠 제작처럼 반복되는 일을 줄이고 실제 운영 방식에 맞는 웹/모바일 앱을 만듭니다.",
    "hero.btnStart": "상담 요청",
    "hero.btnPortfolio": "작업 사례",
    "hero.stat1.num": "운영 중심",
    "hero.stat1.label": "실제 업무 흐름 반영",
    "hero.stat2.num": "빠른 검증",
    "hero.stat2.label": "프로토타입부터 배포까지",
    "hero.stat3.num": "유지보수",
    "hero.stat3.label": "출시 후 개선 지원",
    "hero.code.specialty": "맞춤형 앱 개발",
    "hero.code.focus": '["중소기업", "개인"]',
    "hero.code.values": '["업무 흐름", "빠른 검증", "유지보수"]',
    "hero.code.action": "필요한_기능부터_만듭니다();",
    "hero.float1": "맞춤형 모바일 앱",
    "hero.float1.sub": "iOS & Android 네이티브 경험",
    "hero.float2": "데이터 분석 시각화",
    "hero.float2.sub": "한눈에 보는 비즈니스 트렌드",
    "hero.visual.label": "최근 작업",
    "hero.visual.title": "프랜차이즈 오더 시스템",

    // Services Section
    "services.tag": "Services",
    "services.title": "필요한 기능만 정확하게 만듭니다",
    "services.subtitle": "작게 시작해 실제 운영에서 검증하고, 필요한 만큼 확장할 수 있게 설계합니다.",
    
    "services.s1.title": "맞춤형 앱 개발 (Custom App)",
    "services.s1.desc": "예약, 주문, 멤버십, 내부 관리처럼 업무에 필요한 모바일/웹 앱을 범위에 맞게 설계하고 개발합니다.",
    "services.s1.f1": "사용자 친화적 UI/UX 설계",
    "services.s1.f2": "고성능 프레임워크 기반 하이브리드 개발",
    "services.s1.f3": "간편 결제 및 푸시 알림 연동",

    "services.s2.title": "프랜차이즈 & 백엔드 시스템",
    "services.s2.desc": "가맹점 관리, 주문 처리, POS 연동 등 매장 운영을 정리하는 백오피스 솔루션을 구축합니다.",
    "services.s2.f1": "실시간 주문 알림 및 접수",
    "services.s2.f2": "체계적인 매출 대시보드 통계",
    "services.s2.f3": "역할별 계정 권한 및 지점 관리",

    "services.s3.title": "비즈니스 자동화 (Automation)",
    "services.s3.desc": "반복적인 데이터 입력, 콘텐츠 생성, 자료 수집 같은 수작업 업무를 자동화합니다.",
    "services.s3.f1": "AI 기반 콘텐츠 생성 및 업로드",
    "services.s3.f2": "데이터 자동 수집 및 정리",
    "services.s3.f3": "텔레그램 / 슬랙 알림 봇 연동",

    "services.s4.title": "데이터 분석 및 인사이트",
    "services.s4.desc": "웹 데이터 수집, 리포트 생성, 통계 대시보드를 필요한 지표 중심으로 구성합니다.",
    "services.s4.f1": "유튜브/SNS 트렌드 분석 및 예측",
    "services.s4.f2": "실시간 차트 및 인터랙티브 그래프",
    "services.s4.f3": "엑셀/PDF 리포팅 자동 생성",

    // Portfolio Section
    "portfolio.tag": "Portfolio",
    "portfolio.title": "작업 사례",
    "portfolio.subtitle": "실제로 제작한 앱과 내부 도구를 기준으로 정리했습니다.",
    
    "portfolio.p1.badge": "Rails 웹앱",
    "portfolio.p1.title": "Oh! Cake Bakery 주문 접수 앱",
    "portfolio.p1.desc": "커스텀 케이크 문의를 받는 공개 베이커리 사이트와 주문 접수 백오피스를 함께 만든 Rails 앱입니다. 고객 정보, 행사 일정, 참고 이미지 업로드, 간단한 드로잉 메모까지 접수할 수 있습니다.",
    "portfolio.p1.b1": "고객명, 연락처, 행사일, 인원수 기반 주문 문의 접수",
    "portfolio.p1.b2": "참고 사진 다중 업로드와 캔버스 드로잉 메모 저장",
    "portfolio.p1.b3": "관리자 로그인 및 문의 상세 확인용 백오피스",

    "portfolio.p2.badge": "점검 플랫폼",
    "portfolio.p2.title": "인스펙션",
    "portfolio.p2.desc": "프랜차이즈 본부가 매장 위생, 운영, 품질 점검을 표준 체크리스트로 관리하는 Rails API와 Flutter 앱입니다. 점검 작성, 사진 증빙, 이미지 주석, 점수 계산, 개선 조치까지 하나의 흐름으로 연결했습니다.",
    "portfolio.p2.b1": "매장 선택, 템플릿 로딩, 점검 시작까지 이어지는 현장 앱",
    "portfolio.p2.b2": "사진 업로드, 펜/화살표/도형 주석, 필수 증빙 검증",
    "portfolio.p2.b3": "점수 리포트, 히스토리, 개선 조치, 본부 대시보드",

    "portfolio.p3.badge": "오더시스템",
    "portfolio.p3.title": "프랜차이즈 오더 시스템",
    "portfolio.p3.desc": "베이커리 도매 거래처가 상품을 발주하고 본부가 상품, 재고, 주문, 거래처를 관리하는 Rails 기반 발주 시스템입니다. 거래처 주문 화면과 관리자 백오피스를 분리해 실제 운영 흐름에 맞췄습니다.",
    "portfolio.p3.b1": "거래처별 로그인, 상품 조회, 장바구니 발주",
    "portfolio.p3.b2": "품절 비활성화, 주문 이력 확인, 접수 전 주문 취소",
    "portfolio.p3.b3": "본부용 상품/재고/거래처 관리와 주문 상태 처리",

    "portfolio.p4.badge": "모바일 앱",
    "portfolio.p4.title": "Daily Toon 하루네컷",
    "portfolio.p4.desc": "짧은 일기를 작성하면 네 컷 만화 형태로 간직하는 Expo 기반 모바일 앱입니다. 홈, 일기 작성, 생성 결과, 갤러리 화면과 Firebase 데이터 모델을 기준으로 구조를 잡았습니다.",
    "portfolio.p4.b1": "오늘의 감정과 장면을 남기는 일기 작성 화면",
    "portfolio.p4.b2": "더미 만화 결과 미리보기와 저장 액션 흐름",
    "portfolio.p4.b3": "생성한 하루네컷을 날짜별로 모아보는 갤러리 구조",

    // Process Section
    "process.tag": "Process",
    "process.title": "작게 확인하고 빠르게 고칩니다",
    "process.subtitle": "초기 상담부터 배포 후 개선까지, 확인 가능한 단위로 나누어 진행합니다.",
    "process.step1.title": "요구사항 정의 및 상담",
    "process.step1.desc": "대상 사용자, 핵심 기능, 필요한 연동을 먼저 정리하고 개발 범위와 우선순위를 잡습니다.",
    "process.step2.title": "UI/UX 기획 및 프로토타입",
    "process.step2.desc": "주요 화면과 사용자 흐름을 먼저 확인해 기능이 과하거나 부족하지 않은지 맞춥니다.",
    "process.step3.title": "고성능 프런트엔드 & 백엔드 개발",
    "process.step3.desc": "검증된 기술 스택으로 클라이언트와 서버를 만들고, 운영 중 수정하기 쉬운 구조를 유지합니다.",
    "process.step4.title": "밀도 높은 테스트 및 QA",
    "process.step4.desc": "핵심 업무 흐름, 화면 반응, 권한, 배포 환경을 점검하고 문제를 고칩니다.",
    "process.step5.title": "배포 릴리즈 및 지속적인 서포트",
    "process.step5.desc": "웹 배포나 앱 심사 등록을 진행하고, 출시 후 필요한 수정과 기능 개선을 이어갑니다.",

    // Contact Section
    "contact.tag": "Contact Us",
    "contact.title": "프로젝트의 첫 시작,<br>dataworkman과 함께하세요.",
    "contact.desc": "만들고 싶은 앱이나 줄이고 싶은 반복 업무가 있다면 현재 상황부터 편하게 알려주세요.",
    "contact.email.title": "이메일 문의",
    
    "contact.form.name": "성함 / 담당자명",
    "contact.form.company": "회사명 / 단체명",
    "contact.form.email": "이메일 주소",
    "contact.form.type": "문의 유형",
    "contact.form.type.placeholder": "문의 유형을 선택해 주세요",
    "contact.form.type.app": "맞춤형 모바일/웹 앱 개발",
    "contact.form.type.auto": "업무 프로세스 및 AI 자동화",
    "contact.form.type.data": "데이터 분석 및 크롤링 솔루션",
    "contact.form.type.etc": "기타 상담 문의",
    "contact.form.budget": "예상 프로젝트 예산",
    "contact.form.budget.b1": "500만 원 미만",
    "contact.form.budget.b2": "500만 원 ~ 1,500만 원",
    "contact.form.budget.b3": "1,500만 원 ~ 3,000만 원",
    "contact.form.budget.b4": "3,000만 원 이상",
    "contact.form.desc": "프로젝트 상세 내용",
    "contact.form.desc.placeholder": "기획 의도, 구현하고 싶은 주요 기능, 선호하시는 벤치마킹 서비스 등을 기재해 주세요.",
    "contact.form.submit": "문의 신청하기",

    // Validation & Modal
    "val.error.name": "성함을 입력해 주세요.",
    "val.error.email": "유효한 이메일 주소를 입력해 주세요.",
    "val.error.type": "문의 유형을 선택해 주세요.",
    "val.error.desc": "상세 내용을 입력해 주세요.",
    "val.error.submit": "전송 중 문제가 생겼습니다. 잠시 후 다시 시도해 주세요.",
    "val.sending": "전송 중...",
    
    "modal.title": "성공적으로 접수되었습니다!",
    "modal.desc": "문의하신 내용을 꼼꼼히 확인한 후, 기재해주신 이메일 주소로 영업일 기준 24시간 이내에 자세한 안내 답변을 드리겠습니다.",
    "modal.btn": "확인",

    // Footer
    "footer.desc": "개인과 중소기업을 위한 맞춤형 앱 개발과 업무 자동화.",
    "footer.terms": "이용약관",
    "footer.privacy": "개인정보처리방침"
  },
  
  en: {
    // Navigation
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.portfolio": "Portfolio",
    "nav.process": "Process",
    "nav.contact": "Get in Touch",

    // Hero Section
    "hero.badge": "Custom software for small business",
    "hero.title": "Practical apps and automation<br>for day-to-day operations",
    "hero.subtitle": "We build web and mobile tools around how your team actually handles orders, bookings, content, and back-office work.",
    "hero.btnStart": "Request a consult",
    "hero.btnPortfolio": "See work",
    "hero.stat1.num": "Operations first",
    "hero.stat1.label": "Built around real workflows",
    "hero.stat2.num": "Fast validation",
    "hero.stat2.label": "Prototype to deployment",
    "hero.stat3.num": "Maintenance",
    "hero.stat3.label": "Post-launch improvements",
    "hero.code.specialty": "Custom App Development",
    "hero.code.focus": '["SMEs", "Individuals"]',
    "hero.code.values": '["Workflow", "Validation", "Maintenance"]',
    "hero.code.action": "buildYourDreamProject();",
    "hero.float1": "Custom Mobile App",
    "hero.float1.sub": "Native iOS & Android experience",
    "hero.float2": "Data Visualization",
    "hero.float2.sub": "Business trends at a glance",
    "hero.visual.label": "Recent work",
    "hero.visual.title": "Franchise Order System",

    // Services Section
    "services.tag": "Services",
    "services.title": "Focused tools, built to fit",
    "services.subtitle": "Start with the useful core, validate it in real operations, and expand when it makes sense.",
    
    "services.s1.title": "Custom App Development",
    "services.s1.desc": "We design and develop high-performance mobile apps that perfectly reflect your core business requirements.",
    "services.s1.f1": "User-centric UI/UX design",
    "services.s1.f2": "Hybrid app development via robust frameworks",
    "services.s1.f3": "Seamless payment and push notification integration",

    "services.s2.title": "Franchise & Backend Systems",
    "services.s2.desc": "We build back-office solutions that support your store business, such as order processing and POS integration.",
    "services.s2.f1": "Real-time order alerts and acceptance",
    "services.s2.f2": "Structured revenue dashboard & statistics",
    "services.s2.f3": "Role-based accounts & multi-store management",

    "services.s3.title": "Business Automation",
    "services.s3.desc": "Automate repetitive manual tasks like data entry and content creation using AI and web crawlers.",
    "services.s3.f1": "AI-powered content generation & publishing",
    "services.s3.f2": "Automated data harvesting & structuring",
    "services.s3.f3": "Telegram & Slack alert bot integrations",

    "services.s4.title": "Data Analytics & Insights",
    "services.s4.desc": "We design tailor-made large-scale web scraping and dashboard visualization tools to guide your growth.",
    "services.s4.f1": "YouTube & SNS trend analysis & forecasting",
    "services.s4.f2": "Real-time charts & interactive data flow",
    "services.s4.f3": "Automated Excel & PDF report generation",

    // Portfolio Section
    "portfolio.tag": "Portfolio",
    "portfolio.title": "Featured Projects",
    "portfolio.subtitle": "Actual apps and internal tools built around real product and workflow needs.",
    
    "portfolio.p1.badge": "Rails Web App",
    "portfolio.p1.title": "Oh! Cake Bakery Order Intake App",
    "portfolio.p1.desc": "A Rails app combining a public custom-cake bakery site with an order intake back office. Customers can submit contact details, event dates, reference photos, and quick drawing notes.",
    "portfolio.p1.b1": "Order inquiries with customer, contact, event date, and guest-count fields",
    "portfolio.p1.b2": "Multiple reference image uploads and canvas drawing notes",
    "portfolio.p1.b3": "Admin login and back-office screens for reviewing inquiries",

    "portfolio.p2.badge": "Inspection Platform",
    "portfolio.p2.title": "Inspection",
    "portfolio.p2.desc": "A Rails API and Flutter app for franchise HQ teams to manage store hygiene, operations, and quality inspections with standardized checklists. The workflow connects inspections, photo evidence, image annotations, scoring, and corrective actions.",
    "portfolio.p2.b1": "Field app flow for store selection, template loading, and inspection start",
    "portfolio.p2.b2": "Photo uploads, pen/arrow/shape annotations, and required evidence checks",
    "portfolio.p2.b3": "Score reports, history, corrective actions, and HQ dashboard",

    "portfolio.p3.badge": "Order System",
    "portfolio.p3.title": "Franchise Order System",
    "portfolio.p3.desc": "A Rails-based ordering system where bakery wholesale customers place product orders and HQ manages products, stock, orders, and trading partners. Customer ordering and admin back-office flows are separated for real operations.",
    "portfolio.p3.b1": "Partner login, product browsing, and cart-based ordering",
    "portfolio.p3.b2": "Sold-out item disabling, order history, and pending-order cancellation",
    "portfolio.p3.b3": "HQ product, inventory, partner, and order-status management",

    "portfolio.p4.badge": "Mobile App",
    "portfolio.p4.title": "Daily Toon",
    "portfolio.p4.desc": "An Expo mobile app that turns short diary entries into a four-panel comic keepsake. The current build defines home, diary writing, result preview, gallery screens, and the Firebase data model.",
    "portfolio.p4.b1": "Diary writing screen for today's mood and scenes",
    "portfolio.p4.b2": "Four-panel preview flow with a save action",
    "portfolio.p4.b3": "Gallery structure for browsing generated comics by date",

    // Process Section
    "process.tag": "Process",
    "process.title": "Our Transparent Process",
    "process.subtitle": "From initial consultation to final release and post-launch support, we deliver step by step.",
    "process.step1.title": "1. Discovery & Consultation",
    "process.step1.desc": "We discuss your target audience, functional scope, and integrations to provide an optimal quote and roadmap.",
    "process.step2.title": "2. UI/UX & Prototyping",
    "process.step2.desc": "We build wireframes and high-fidelity interactive Figma prototypes to align design before writing code.",
    "process.step3.title": "3. High-Performance Development",
    "process.step3.desc": "We select scalable tech stacks to develop clean client applications and robust, secure backend servers.",
    "process.step4.title": "4. Rigorous Testing & QA",
    "process.step4.desc": "We test across multiple operating systems and devices for bugs, performance bottlenecks, and security gaps.",
    "process.step5.title": "5. Deployment & Ongoing Support",
    "process.step5.desc": "We handle store submissions (App Store / Play Store) and provide system monitoring and feature updates.",

    // Contact Section
    "contact.tag": "Contact Us",
    "contact.title": "Start Your Project<br>with dataworkman.",
    "contact.desc": "We don't just write code; we solve business problems. Reach out to discuss your ideas or automation requirements.",
    "contact.email.title": "Email Inquiry",
    
    "contact.form.name": "Name / Contact Person",
    "contact.form.company": "Company / Organization",
    "contact.form.email": "Email Address",
    "contact.form.type": "Inquiry Type",
    "contact.form.type.placeholder": "Please select inquiry type",
    "contact.form.type.app": "Custom Mobile/Web App",
    "contact.form.type.auto": "Workflow & AI Automation",
    "contact.form.type.data": "Data Scraper & Dashboard",
    "contact.form.type.etc": "General Consulting",
    "contact.form.budget": "Estimated Budget",
    "contact.form.budget.b1": "Under $5k",
    "contact.form.budget.b2": "$5k - $15k",
    "contact.form.budget.b3": "$15k - $30k",
    "contact.form.budget.b4": "Over $30k",
    "contact.form.desc": "Project Details",
    "contact.form.desc.placeholder": "Please describe your project goals, core features, or reference apps you like.",
    "contact.form.submit": "Submit Request",

    // Validation & Modal
    "val.error.name": "Please enter your name.",
    "val.error.email": "Please enter a valid email address.",
    "val.error.type": "Please select an inquiry type.",
    "val.error.desc": "Please enter project details.",
    "val.error.submit": "Something went wrong while sending. Please try again shortly.",
    "val.sending": "Sending...",
    
    "modal.title": "Request Successfully Received!",
    "modal.desc": "We will review your inquiry carefully and get back to your email within 24 business hours.",
    "modal.btn": "Confirm",

    // Footer
    "footer.desc": "Custom business applications and automation agency for individuals and SMEs.",
    "footer.terms": "Terms of Service",
    "footer.privacy": "Privacy Policy"
  }
};
